import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import { Namespace } from '../../enum';
import {
    State,
    mapStateToProps,
} from './selector';
import overlayReducer from './reducer';
import * as overlayActions from './action';
import saga from './saga';
import {
    mountOverlay,
    setOverlayActiveContent,
    setOverlayVisibility,
} from '../../components/overlay';
import { AppId } from '../../enums/elementId';
import { getUpdateFlags } from './update';
import lmContainer from '../LeadManagementForm/index';
import avcContainer from '../AvailabilityCheck/index';
import legalContainer from '../Legal/index';
import {
    mountLoadingSpinner,
    setLoadingSpinnerVisibility,
} from '../../components/loadingSpinner';
import { LoadingSpinner } from '@vfde-brix/ws10/loading-spinner';
import { loadTvFootnote } from '../App/action';

const mapDispatch = {
    ...overlayActions,
    loadTvFootnote,
};

function container (state: State, actions: typeof mapDispatch) {
    const overlay = mountOverlay(AppId.OVERLAY, () => {
        actions.setOverlayVisibility(false);
        actions.cancelAvailabilityCheck();
    });
    let loadingSpinner: LoadingSpinner | null = null;

    injectReducer(Namespace.OVERLAY, overlayReducer);
    injectSaga(Namespace.OVERLAY, saga);

    if (overlay) {
        actions.initOverlay(overlay);
    }

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);
            const { activeContent, isOpen, isLoaded, isLoading } = newState;

            if (update.loaded) {
                lmContainer();
                avcContainer();
                legalContainer();
                loadingSpinner = mountLoadingSpinner(AppId.OVERLAY_LOADING, true);
                actions.loadTvFootnote();
            }

            if (isLoaded) {
                update.loading && setLoadingSpinnerVisibility(loadingSpinner, isLoading);
                update.content && setOverlayActiveContent(activeContent);
                update.visibility && setOverlayVisibility(isOpen);
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
